export function htmlToDocumentFragment($document, html) {
    const templateEl = $document.createElement("template");
    templateEl.innerHTML = html;
    return templateEl.content;
}
